const getRadarDataFields = () => {
  return [
    {
      title: "Dimension",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Metrics",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "valueColumns",
      itemInArray: true,
    },
    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Check Box",
      type: "checkBox",
      defaultValue: false,
      reduxKey: "checkBox",
    },
  ];
};

export { getRadarDataFields };
const getRadarCustomizationFields = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Outer Radius",
      type: "range",
      defaultValue: 225,
      minValue: 100,
      maxValue: 265,
      reduxKey: "outerRadius",
    },

    {
      title: "Point Size",
      type: "range",
      defaultValue: 3,
      minValue: 0,
      maxValue: 20,
      reduxKey: "pointSize",
      itemInArray: false,
    },

    // {
    //   title: "Padding Angle2",
    //   type: "text",
    //   defaultValue: 0,
    //   minValue: 0,
    //   maxValue: 40,
    //   reduxKey: "paddingAngle2",
    // },

    {
      title: "Cutome Tooltip",
      type: "checkbox",
      defaultValue: true,
      reduxKey: "customeTooltip",
    },

    //label
    {
      title: "Label",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: false,
      reduxKey: "isLabelVisible",
      innerComponents: [
        // {
        //   title: "Position",
        //   type: "SELECT_BOX",
        //   reduxKey: "labelPosition",
        //   options: [
        //     { label: "Outside", value: "outside" },
        //     { label: "Inside", value: "inside" },
        //     { label: "Center", value: "center" },
        //   ],
        //   defaultValue: { label: "Outside", value: "outside" },
        // },

        // {
        //   title: "Font Size",
        //   type: "range",
        //   defaultValue: 18,
        //   minValue: 16,
        //   maxValue: 90,
        //   reduxKey: "labelFontSize",
        // },

        {
          title: "Font Color",
          type: "fontColor",
          reduxKey: "labelFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 15,
          minValue: 12,
          maxValue: 90,
          reduxKey: "labelFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },

        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelRotate",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },

    {
      title: "Legend",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isLegendVisible",
      innerComponents: [
        {
          title: "Align",
          type: "SELECT_BOX",
          reduxKey: "legendAlign",
          options: [
            { label: "Left", value: "left" },
            { label: "Center", value: "center" },
            { label: "Right", value: "right" },
          ],
          defaultValue: { label: "Center", value: "center" },
          isParent: true,
        },
        {
          title: "Vertical Align",
          type: "SELECT_BOX",
          reduxKey: "legendVerticalAlign",
          options: [
            { label: "Top", value: "top" },
            { label: "Middle", value: "middle" },
            { label: "Bottom", value: "bottom" },
          ],
          defaultValue: { label: "Bottom", value: "bottom" },
          isParent: true,
        },
        {
          title: "Layout",
          type: "SELECT_BOX",
          reduxKey: "legendLayout",
          options: [
            { label: "Horizontal", value: "horizontal" },
            { label: "Vertical", value: "vertical" },
          ],
          defaultValue: { label: "Horizontal", value: "horizontal" },
          isParent: true,
        },
      ],
    },
  ];
};

export { getRadarCustomizationFields };
